module.exports = __webpack_public_path__ + "img/page9.cabaaf67.jpg";